import api from './index';

export default {
  index(params) {
    return api({ method: 'get', url: 'api/statements', params });
  },
  getById(id) {
    return api({ method: 'get', url: `api/statements/${id}` });
  },
  create(formData) {
    return api({
      method: 'post',
      url: 'api/statements',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  submitPassword(id, password) {
    return api({ method: 'post', url: `api/statements/${id}/submit-password`, data: { password } });
  },
  commit(id, resolutions) {
    return api({ method: 'post', url: `api/statements/${id}/commit`, data: { resolutions } });
  },
  reprocess(id) {
    return api({ method: 'post', url: `api/statements/${id}/reprocess` });
  },
};
